module.exports = __webpack_public_path__ + "static/media/SHOMOSHTEE-LOGO.5980d31f.png";